import { Component, HostListener, OnInit } from "@angular/core";
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { DialogUtils } from "@app/DialogUtils";
import { MessageUtils } from "@app/MessageUtils";
import { User } from "@app/models/User";
import { AuthService } from "@app/services/auth/auth.service";
import { EntidadService } from "@app/services/entidad/entidad.service";
import { GeneroService } from "@app/services/genero/genero.service";
import { NacionalidadService } from "@app/services/nacionalidad/nacionalidad.service";
import { PerfilService } from "@app/services/perfil/perfil.service";
import { TitulacionService } from "@app/services/titulacion/titulacion.service";
import { UserService } from "@app/services/user/user.service";
import { ValidateUtils } from "@app/ValidateUtils";
import { AppService, SessionStorageService } from "@mova/components/core";
import moment, { now } from "moment";
import { forkJoin, Subject, Subscription } from "rxjs";
import * as _ from 'lodash';

@Component({
  selector: "app-acceso-usuario-registrado",
  templateUrl: "./acceso-usuario-registrado.component.html",
  styleUrls: ["./acceso-usuario-registrado.component.scss"],
})
export class AccesoUsuarioRegistradoComponent implements OnInit {
  formUser: FormGroup;

  isLogged: Boolean;
  hasChangeForm: Boolean;
  isViewAllForm: Boolean;
  isSetListSelectsFormStepTwo: Boolean; //Verificar si la lista del paso 2 ya se ha hecho.
  userData: User;
  userDataNew: User;

  //Campos del formulario
  cdNombre: FormControl;
  cdApellidos: FormControl;
  cdNifNie: FormControl;
  tipoDocumento: FormControl;
  fcNacimiento: FormControl;
  idGenero: FormControl;
  cdTelefono: FormControl;
  cdMailPersonal: FormControl;
  institucion: FormControl;
  idPerfil: FormControl;
  cdMailUniversidad: FormControl;
  fcValidez: FormControl;
  privacidad: FormControl;
  cdCodigoPostal: FormControl;
  titulacion: FormControl;
  nacionalidad: FormControl;

  maxDate: Date;

  private selectOptionsGenero: Array<any>;
  private selectOptionsInstitution: Array<any>;
  private selectOptionsPerfil: Array<any>;
  private selectOptionsTitulacion: Array<any>;
  private selectOptionsNacionalidad: Array<any>;

  private selectOptionsDocumento = [
    {
      id: 1,
      text: "NIF/NIE",
    },
    {
      id: 2,
      text: "Pasaporte",
    },
  ];

  //Lista a mostrar a la izquierda del formulario de los pasos.
  listStep = [
    {
      step: 1,
      text: "Datos personales",
    },
    {
      step: 2,
      text: "Datos Académicos",
    },
  ];

  stepLength: number; //El número de pasos que hay en el formulario
  activeStep: number = 1; //Paso actual del formulario

  /* Evento step para emitir cambios*/
  stepSubject: Subject<String> = new Subject<String>();

  // Suscripción del formulario.
  formSubscription: Subscription;

  textButtonSaveOrDarseAlta: string;
  labelNifNiePassport: string;

  constructor(
    private _appService: AppService,
    public dialog: MatDialog,
    private router: Router,
    private _userService: UserService,
    private _nacionalidadService: NacionalidadService,
    private _titulacionService: TitulacionService,
    private _perfilService: PerfilService,
    private _entidadService: EntidadService,
    private _generoService: GeneroService,
    private _sessionStorageService: SessionStorageService,
    private _authService: AuthService
  ) {
    this.stepLength = Object.keys(this.listStep).length;

    this.hasChangeForm = false;

    this.selectOptionsGenero = new Array<any>();
    this.selectOptionsInstitution = new Array<any>();
    this.selectOptionsPerfil = new Array<any>();
    this.selectOptionsTitulacion = new Array<any>();
    this.selectOptionsNacionalidad = new Array<any>();
    this.isSetListSelectsFormStepTwo = false;
    this.isViewAllForm = false;
    let currentYear = new Date().getFullYear();
    this.maxDate = new Date(currentYear, 7, 31);
  }

  ngOnInit(): void {
    this.setupAccesoUsuarioRegistrado();

    //Nota: Los meses se cuentan a partir de 0 y no de 1 por cómo está hecho el Date de MOVA.
    let date = new Date(new Date().getFullYear() + 1, 8, 30);

    this.formUser.controls.fcValidez.setValue(date, { onlySelf: true });
    this.formUser.controls.fcValidez.disable();

    if (!this.isLogged){this.formUser.controls.tipoDocumento.setValue(1, {onlySelf: true});}

    if (this._authService.isLogged()) {
      this.isLogged = true;
      this.textButtonSaveOrDarseAlta = MessageUtils.TEXT_BUTTON_GUARDAR;
    } else {
      this.isLogged = false;
      this.textButtonSaveOrDarseAlta = MessageUtils.TEXT_BUTTON_DARSEDEALTA;
    }
    this.onChanges();

  }


  /**
   * Inicializa el formulario de alta/modificación.
   */
  setupAccesoUsuarioRegistrado() {
    this.createFormUser();
    this.setListSelectsFormStepOne();
  }

  /**
   * Rellena las listas del paso 1 con datos del usuario.
   */
  setListSelectsFormStepOne() {
    forkJoin({
      reqNacionalidad: this._nacionalidadService.getListNacionalidad(),
      reqGeneros: this._generoService.getGeneros(),
    }).subscribe(({ reqNacionalidad, reqGeneros }) => {
      //Nacionalidad
      reqNacionalidad.data.data.forEach((element) => {
        this.selectOptionsNacionalidad.push({
          id: element.cdPais,
          text: element.dsPais,
        });
      });

      //Genero
      reqGeneros.data.data.forEach((element) => {
        this.selectOptionsGenero.push({
          id: element.idGenero,
          text: element.cdDescripcion,
        });
      });

      if (this._authService.isLogged()) {
        this.setupDataFormStepOne(this.formUser);

      }
    });
  }

  /**
   * Rellena las listas del paso 2 con datos del usuario.
   */
  setListSelectsFormStepTwo() {
    forkJoin({
      reqTitulacion: this._titulacionService.getListTitulacion(),
      reqPerfil: this._perfilService.getListPerfil(),
      reqEntidad: this._entidadService.getListEntidad(),
    }).subscribe(({ reqTitulacion, reqPerfil, reqEntidad }) => {

      this.selectOptionsTitulacion.push({
        id: -1,
        text: 'Ninguna',
      })

      //Titulación
      reqTitulacion.data.data.forEach((element) => {
        this.selectOptionsTitulacion.push({
          id: element.idTitulacion,
          text: element.dsNombre,
        });
      });



      //Perfil
      reqPerfil.data.data.forEach((element) => {
        this.selectOptionsPerfil.push({
          id: element.idPerfil,
          text: element.cdDescripcion,
        });
      });

      //Institucion
      reqEntidad.data.data.forEach((element) => {
        this.selectOptionsInstitution.push({
          id: element.idEntidad,
          text: element.cdDescripcion,
        });
      });

      this.isSetListSelectsFormStepTwo = true;
      this.isViewAllForm = true;

      if (this._authService.isLogged()) {
        this.setupDataFormStepTwo(this.formUser);

      }
    });
  }

  /**
   * Rellena y desactiva datos del usuario en el primer paso del formulario.
   */
  setupDataFormStepOne(form: FormGroup) {
    let user: User = this._sessionStorageService.getItem(MessageUtils.DATA_USER);

    let dataForm = form.controls;
    dataForm.cdNombre.setValue(user.cdNombre);
    dataForm.cdApellidos.setValue(user.cdApellidos);
    dataForm.cdNifNie.setValue(user.cdNifNie);

    if (ValidateUtils.validateNifPassport(dataForm.cdNifNie.value)) {

      this.formUser.controls.tipoDocumento.setValue(1, {onlySelf: true});
    } else {

      this.formUser.controls.tipoDocumento.setValue(2, {onlySelf: true});
    }

    dataForm.cdCodigoPostal.setValue(user.cdCodigoPostal);
    dataForm.cdNifNie.disable();
    dataForm.tipoDocumento.disable();
    dataForm.nacionalidad.setValue(user.nacionalidadDTO.cdPais, {onlySelf: true,});
    dataForm.fcNacimiento.setValue(new Date(user.fcNacimiento), {onlySelf: true,});
    dataForm.cdMailPersonal.setValue(user.cdMailPersonal);
    dataForm.idGenero.setValue(user.generoDTO.idGenero, { onlySelf: true });
  }

  /**
   * Rellena y desactiva datos del usuario en el segundo paso del formulario.
   */
  setupDataFormStepTwo(form: FormGroup) {
    let user: User = this._sessionStorageService.getItem(MessageUtils.DATA_USER);

    let dataForm = form.controls;


    dataForm.institucion.setValue(user.entidadDTO.idEntidad, {onlySelf: true,});
    if (user.titulacionDTO != null)  {
      dataForm.titulacion.setValue(user.titulacionDTO.idTitulacion, {onlySelf: true,});
    } else {
      dataForm.titulacion.setValue(-1, { onlySelf: true });
    }

    dataForm.idPerfil.setValue(user.perfilDTO.idPerfil, { onlySelf: true });
    dataForm.cdMailUniversidad.setValue(user.cdMailUniversidad, {onlySelf: true,});
    dataForm.fcValidez.setValue(new Date(user.carnetDTO.fcValidez), {onlySelf: true,});
    dataForm.cdMailUniversidad.disable();






  }

  /**
   * Comprueba si las listas por cada paso existente en el formulario han sido rellenadas con datos.
   */
  checkSetListSelectOptions() {
    if (this.activeStep == 2 && !this.isSetListSelectsFormStepTwo) {
      this.setListSelectsFormStepTwo();
    }
  }

  /**
   * Crea el formulario para los datos del usuario.
   */
  private createFormUser() {
    this.formUser = new FormGroup({
      cdNombre: new FormControl("", [Validators.required]),
      cdApellidos: new FormControl("", [Validators.required]),
      cdNifNie: new FormControl("", [
        Validators.required,
      ]),
      tipoDocumento: new FormControl("", []),
      fcNacimiento: new FormControl("", []),
      idGenero: new FormControl("", []),
      cdTelefono: new FormControl("", [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(10),
      ]),
      cdMailPersonal: new FormControl("", [Validators.email]),
      institucion: new FormControl("", [Validators.required]),
      idPerfil: new FormControl("", [Validators.required]),
      cdMailUniversidad: new FormControl("", [
        Validators.required,
        Validators.email,
      ]),
      fcValidez: new FormControl(""),
      privacidad: new FormControl("", [Validators.required]),
      cdCodigoPostal: new FormControl("", [
        Validators.required,
        Validators.pattern('([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}')
      ]),
      titulacion: new FormControl(""),
      nacionalidad: new FormControl(""),
    });

    this.setFormControlUserVariables();
  }

  //TODO: Pendiente revisar para ponerlo en ValidateUtils.
  /**
   *
   * @param format Fecha a validar en formato "MM/dd/YYYY"
   * @returns null si la fecha es válida o invalidDate:true si la fecha no es válida.
   */
  dateValidator(format = "MM/dd/YYYY"): any {

    return (control: FormControl): { [key: string]: any } => {
      const val = moment(control.value, format, true);

      if (!val.isValid()) {
        return { invalidDate: true };
      }

      return null;
    };
  }

  /**
   * Establece el controlador de variables del formulario formUser.
   */
  private setFormControlUserVariables() {
    this.cdNombre = this.formUser.controls.cdNombre as FormControl;
    this.cdApellidos = this.formUser.controls.cdApellidos as FormControl;
    this.cdNifNie = this.formUser.controls.cdNifNie as FormControl;
    this.tipoDocumento = this.formUser.controls.tipoDocumento as FormControl;
    this.fcNacimiento = this.formUser.controls.fcNacimiento as FormControl;
    this.idGenero = this.formUser.controls.idGenero as FormControl;
    this.cdTelefono = this.formUser.controls.cdTelefono as FormControl;
    this.cdMailPersonal = this.formUser.controls.cdMailPersonal as FormControl;
    this.institucion = this.formUser.controls.institucion as FormControl;
    this.idPerfil = this.formUser.controls.idPerfil as FormControl;
    this.cdMailUniversidad = this.formUser.controls.cdMailUniversidad as FormControl;
    this.fcValidez = this.formUser.controls.fcValidez as FormControl;
    this.privacidad = this.formUser.controls.privacidad as FormControl;
    this.cdCodigoPostal = this.formUser.controls.cdCodigoPostal as FormControl;
    this.titulacion = this.formUser.controls.titulacion as FormControl;
    this.nacionalidad = this.formUser.controls.nacionalidad as FormControl;
  }

  onChangeTipoDocumento() {
    if (this.formUser.controls.tipoDocumento.value == 1) {

      this.formUser.controls.cdNifNie.clearValidators();
      this.formUser.controls.cdNifNie.setValidators(ValidateUtils.validateNifPassportForm);
    } else {


      this.formUser.controls.cdNifNie.clearValidators();
      this.formUser.controls.cdNifNie.setValidators(Validators.pattern('[-a-zA-Z0-9]*'));
    }

    this.formUser.controls.cdNifNie.updateValueAndValidity();
  }

  onChangePerfil() {

    if (this.formUser.controls.idPerfil.value !=1) {
      this.formUser.controls.titulacion.setValue(-1, {onlySelf:true});
    }
  }


  /**
   * Por cada cambio en el formulario, verificará la validez.
   */
  onChanges(): void {

    let tipoDocumento = this.formUser.controls.tipoDocumento.value;
    this.formSubscription = this.formUser.valueChanges.subscribe((val) => {

      this.checkForm();
      this.labelNifNiePassport = this.selectOptionsDocumento[(this.formUser.controls.tipoDocumento.value)-1].text;
    });
  }

  /**----------------------------------------------------------------------------
   * Intento de comprobar si el formulario está modificado.
  // checkFormModified() {
  //   let result = false;
  //   Object.keys(this.formUser.controls).forEach((control: string) => {
  //     let form;

  //     //NOTA: Como no todas las pantallas se han cargado, necesitamos usar una copia.
  //     if (!this.isViewAllForm) {
  //
  //       form = this.formUserCopy.controls[control].value;
  //     } else {
  //
  //       form = this.formUser.controls[control].value;

  //     }

  //

  //     // const form = this.formUserCopy.controls[control].value;
  //     const formOld= this.formUserOld.controls[control].value;

  //     if (control == 'fcNacimiento' || control == 'fcValidez') {
  //       let date = new Date(form);
  //       let dateOld = new Date(formOld);

  //       if (date.getDay() != dateOld.getDay() || date.getMonth() != dateOld.getMonth() || date.getFullYear() != dateOld.getFullYear()) {
  //         result = true;
  //       } else {
  //
  //       }

  //     } else if (form != formOld) {
  //
  //       result = true;
  //     }
  //   });

  //   return result;
  // }
/**----------------------------------------------------------------------------

  /**
   * Pasa al siguiente paso del formulario.
   */
  nextStep() {
    if (this.checkForm()) {
      this.stepSubject.next("next");
      this.checkSetListSelectOptions();
    }
  }

  /**
   * Vuelve al anterior paso del formulario.
   */
  prevStep() {
    this.stepSubject.next("back");
  }

  /**
   * Comprueba si en el paso actual, están rellenos/bien los campos obligatorios.
   * @return true Si el formulario es válido.
   * @return false Si el formulario no es válido.
   */
  checkForm() {
    let formControl = this.formUser.controls;

    switch (this.activeStep) {
      case 1:
        if (this.isLogged) {
          if (
            formControl.cdNombre.valid &&
            formControl.cdApellidos.valid &&
            formControl.fcNacimiento.valid &&
            formControl.cdMailPersonal.valid &&
            formControl.cdTelefono.valid &&
            formControl.cdCodigoPostal.valid &&
            formControl.nacionalidad.valid
            && formControl.fcNacimiento.valid
          ) {
            return true;
          }
        } else {
          if (
            formControl.cdNombre.valid &&
            formControl.cdApellidos.valid &&
            formControl.cdNifNie.valid &&
            formControl.fcNacimiento.valid &&
            formControl.cdMailPersonal.valid &&
            formControl.cdTelefono.valid &&
            formControl.cdCodigoPostal.valid &&
            formControl.nacionalidad.valid
            && formControl.fcNacimiento.valid
          ) {
            return true;
          }
        }

        return false;
      case 2:
        if (this.isLogged) {
          if (
            formControl.institucion.valid &&
            formControl.idPerfil.valid
          ) {
            return true;
          }
        } else {
          if (
            formControl.institucion.valid &&
            formControl.idPerfil.valid &&
            formControl.cdMailUniversidad.valid &&
            formControl.privacidad.valid
          ) {
            return true;
          }
        }

        return false;
    }
  }

  /**
   * Establece el paso actual del formulario.
   * @param event número del paso actual.
   */
  setStep(event) {
    this.activeStep = event;
  }

  /**
   * Rellena los campos con datos de prueba.
   */
  testRellenarDatos() {

    this.formUser.controls.cdNombre.setValue("Felipe");
    this.formUser.controls.cdApellidos.setValue("Fuentes");
    this.formUser.controls.cdNifNie.setValue("32812835T");
    this.formUser.controls.cdCodigoPostal.setValue("29651");
  }

  /**
   * Abre un diálogo con el texto de la política de privacidad.
   * Acepta: Activa el check.
   * Cancela: Desactivará el check en caso de estar activado.
   */
  openDialogPoliticaPrivacidad(event) {
    let data = DialogUtils.getDialogPrivacy();
    event.preventDefault();

    let self = this;

    //Acción después de elegir una opción en el dialog.
    function successCallback(result: any) {
      if (result.accept) {
        self.formUser.controls.privacidad.setValue(true);
      } else if (result.cancel) {
        self.formUser.controls.privacidad.setValue(false);
      }
    }

    data["successCallback"] = successCallback;
    this._appService.openDialog(data);
  }

  /**
   * Abre un dialog para cancelar el formulario y volver a la pantalla de login.
   */
  openDialogCancelForm() {
    let data = DialogUtils.getDialogCancelForm();

    let self = this;

    //Acción después de elegir una opción en el dialog.
    function successCallback(result: any) {
      if (result.accept) {
        self.router.navigate(["login-view"]);

      }
    }

    data["successCallback"] = successCallback;
    this._appService.openDialog(data);
  }

  /**
   * Abre un dialog con información sobre el correo institucional.
   */
  openDialogInfoCorreoInstitucional() {
    let dialogCorreo = DialogUtils.getDialogInfoCorreoInstitucional();
    this._appService.openDialog(dialogCorreo);
  }

  /**
   * Abre un dialog con información sobre el correo institucional.
   */
  openDialogInfoCodigoPostal() {
    let dialogCodigo = DialogUtils.getDialogInfoCodigoPostal();
    this._appService.openDialog(dialogCodigo);
  }

  /**
   * Abre un dialog de error del formulario.
   * @params  message Mensaje opcional para mostrar el error.
   * @params redirect Redirije al login perdiendo los datos del formulario, por defecto es true.
   */
  openDialogErrorForm(message?:string, redirect:boolean = true) {
    let dialogFormError = DialogUtils.getDialogErrorForm(message);

    let self = this;

    function successCallback(result: any) {
      if (redirect) {
        self.router.navigate(["login-view"]);
      }

    }

    dialogFormError["successCallback"] = successCallback;
    this._appService.openDialog(dialogFormError);
  }

  /**
   * Crea a un usuario en la base de datos.
   * @param user Datos del usuario a crear.
   */
  createUser(user) {
    this._userService.createUser(user).subscribe(
      (data) => {
        let dialogForm = DialogUtils.getDialogRevisarEmail();

        let self = this;

        function successCallback(result: any) {
          self.router.navigate(["login-view"]);
        }

        if (data != undefined && data.data.data.cdUsuAlta == undefined){
          this.openDialogErrorForm(data.data.data,false);
        }else{
          dialogForm["successCallback"] = successCallback;
          this._appService.openDialog(dialogForm);
        }

      },
      (error) => {

        this.openDialogErrorForm(error.error.message, false);
      }
    );
  }

  /**
   * Modifica/Actualiza a un usuario en la base de datos.
   * @param user Datos del usuario para modificar.
   */
  updateUser(user) {
    this._userService.updateUser(user).subscribe(
      (data) => {
        if (data != undefined && data.data.data.cdUsuAlta == undefined){
          this.openDialogErrorForm();
        }else{
          let dialogForm: any = DialogUtils.getDialogSave();
          this._appService.openDialog(dialogForm);
        }
      },
      (error) => {

        this.openDialogErrorForm();
      }
    );
  }

  /**
   * Abre un diálogo comprobando si los datos del formulario han sido modificados.
   * Si han sido modificados dará un aviso.
   * @param user Datos del usuario.
   */
  openDialogEmailCarnet(user) {
    let dialog = DialogUtils.getDialogNotSaveSendEmail();
    let self = this;

    function successCallback(result: any) {
      if (result.accept) {
        self.sendEmailCarnet(user);
      }
    }

    dialog["successCallback"] = successCallback;
    this._appService.openDialog(dialog);

  }

  /**
   * Envía el email con la descargar del carnet.
   * @param user Usuario al que enviar el email.
   */
  sendEmailCarnet(user) {
    this._userService.downloadMail(user).subscribe(
      (data) => {
        let dialogForm = DialogUtils.getDialogSendEmailDownloadCarnet();
        this._appService.openDialog(dialogForm);
      },
      (error) => {

        this.openDialogErrorForm();
      }
    );
  }

  /**
   * Devuelve un error custom de formulario
   * @param campo Campo a comprobar el mensaje de error.
   * @returns
   */
  getFormCustomErrorMessage(campo) {
    return MessageUtils.getFormCustomErrorMessage(campo, this.formUser);
  }

  /**
   * Enviar formulario.
   */
  onSubmit() {
    const formValid = this.formUser.status === "VALID" ? true : false;
    let formData = this.formUser.controls;
    let userDataOld: User = this._sessionStorageService.getItem(MessageUtils.DATA_USER);
    let usuAlta = null;
    let altaFila = null;
    let carnet = {
      idCarnet: null,
      cdNumDescargas: null
    };

    if(userDataOld!=undefined){
      usuAlta= userDataOld.cdUsuAlta;
      altaFila= userDataOld.fcAltaFila;
      carnet = userDataOld.carnetDTO;
    }

    if (this.isLogged) {

      this.userData = {
        idUser: userDataOld.idUser,
        cdNombre: formData.cdNombre.value,
        cdApellidos: formData.cdApellidos.value,
        cdNifNie: userDataOld.cdNifNie, //El dni no podrá ser modificado, en caso de que ocurra se guardará el antiguo dni.
        cdCodigoPostal: formData.cdCodigoPostal.value,
        nacionalidadDTO: { cdPais: formData.nacionalidad.value },
        fcNacimiento: formData.fcNacimiento.value,
        cdMailPersonal: formData.cdMailPersonal.value,
        generoDTO: {idGenero: formData.idGenero.value == "" ? 3 : formData.idGenero.value},
        perfilDTO: { idPerfil: formData.idPerfil.value },
        cdMailUniversidad: userDataOld.cdMailUniversidad, //El email de universidad no podrá ser modificado, en caso de que ocurra se guardará el antiguo email.
        fcUltModif: new Date(Date.now()).toISOString(),
        vfEstado: userDataOld.vfEstado,
        entidadDTO: {idEntidad: formData.institucion.value},
        cdUsuAlta: usuAlta,
        fcAltaFila: altaFila,
        carnetDTO: carnet,
        titulacionDTO: {idTitulacion: formData.titulacion.value == -1 ? null : formData.titulacion.value},
      };

      this.userDataNew = this.userData;
      this.updateUser(this.userData);

    } else {
      this.userData = {
        cdNombre: formData.cdNombre.value,
        cdApellidos: formData.cdApellidos.value,
        cdNifNie: formData.cdNifNie.value,
        cdCodigoPostal: formData.cdCodigoPostal.value,
        nacionalidadDTO: { cdPais: formData.nacionalidad.value },
        fcNacimiento: formData.fcNacimiento.value,
        cdMailPersonal: formData.cdMailPersonal.value,
        generoDTO: {idGenero: formData.idGenero.value == "" ? 3 : formData.idGenero.value,},
        perfilDTO: { idPerfil: formData.idPerfil.value },
        cdMailUniversidad: formData.cdMailUniversidad.value,
        fcUltModif: new Date(Date.now()).toISOString(),
        vfEstado: "1",
        entidadDTO: {idEntidad: formData.institucion.value},
        cdUsuAlta: usuAlta,
        fcAltaFila: altaFila,
        fcValidez: formData.fcValidez.value,
        carnetDTO: carnet,
        titulacionDTO: {idTitulacion: formData.titulacion.value == -1 ? null : formData.titulacion.value},
      };
      this.createUser(this.userData);
    }



  }


  descargaCarnet() {
    const formValid = this.formUser.status === "VALID" ? true : false;
    let userData: User = this._sessionStorageService.getItem(MessageUtils.DATA_USER);

    // if (this.formUser.controls.idPerfil && this.formUser.controls.idPerfil.value != 1) {
    //   this.formUser.controls.titulacion.setValue("", {onlySelf: true});
    // }

    if (this.isLogged) {
      if (this.userDataNew) {

        this.userData = this.userDataNew;
      } else {
        this.userData = {
          idUser: userData.idUser,
          cdNombre: userData.cdNombre,
          cdApellidos: userData.cdApellidos,
          cdNifNie: userData.cdNifNie,
          cdCodigoPostal: userData.cdCodigoPostal,
          nacionalidadDTO: { cdPais: userData.nacionalidadDTO.dsPais },
          fcNacimiento: userData.fcNacimiento,
          cdMailPersonal: userData.cdMailPersonal,
          generoDTO: {idGenero: userData.generoDTO.idGenero.toString() == "" ? 3 : userData.generoDTO.idGenero},
          perfilDTO: { idPerfil: userData.perfilDTO.idPerfil },
          cdMailUniversidad: userData.cdMailUniversidad,
          fcUltModif: new Date(Date.now()).toISOString(),
          vfEstado: userData.vfEstado,
          entidadDTO: { idEntidad: 49 },
          cdUsuAlta: userData.cdUsuAlta,
          fcAltaFila: userData.fcAltaFila,
          carnetDTO: userData.carnetDTO,
        };
      }

      this.openDialogEmailCarnet(this.userData);

    }}

  ngOnDestroy() {
    this.formSubscription.unsubscribe();
    this._authService.deleteSessionData();
  }
}
